'use strict';

angular.module('upAttributes').service('SalesReportAttributes', [
	'FilterType',
	'DisplayType',
	function (FilterType, DisplayType) {
		return function () {
			var attributes = {
				id: {
					title: 'default.id',
					field: 'id',
					type: FilterType.Number,
					displayType: DisplayType.String,
					groupable: false,
					sortable: false,
					selectableColumn: false,
					filterable: false
				},
				date: {
					field: 'date',
					type: FilterType.Date
				},
				description: {
					title: 'default.description',
					field: 'description',
					type: FilterType.String,
					displayType: DisplayType.String,
					inputType: 'text',
					groupable: false,
					sortable: false,
					selectableColumn: true,
					filterable: false
				},
				userId: {
					title: 'default.user',
					field: 'user.id',
					type: FilterType.Number,
					displayType: DisplayType.RefObject,
					filterName: 'userId',
					refParams: {
						type: 'user',
						field: 'name',
						identifyer: 'id',
						refType: 'appointment'
					},
					comparisonTypes: ['Equals', 'NotEquals'],
					inputType: 'select',
					groupable: true,
					sortable: false,
					selectableColumn: true
				},
				contact: {
					title: 'default.contact',
					field: 'contactId',
					type: FilterType.Number
				},
				account: {
					title: 'default.contact',
					field: 'clientId',
					type: FilterType.Number
				}
			};

			var standardFilters = {
				User: {
					field: 'userId',
					title: 'default.users',
					type: 'list'
				}
			};

			return {
				attr: attributes,
				standardFilters: standardFilters,
				getAll: function () {
					return attributes;
				}
			};
		};
	}
]);
